import useTranslation from 'next-translate/useTranslation'
import React from 'react'

import Caption from '@/components/ui/Typo/Caption'
import { APP_NAME } from '@/res/consts'
import { NAMESPACE_DOMAIN } from '@/res/namespaces'

const WhyUztelecom = () => {
  const { t } = useTranslation(NAMESPACE_DOMAIN)
  return (
    <div className="container my-24">
      <div className="tablet:flex justify-between tablet:space-x-6 my-4">
        <div className="small:w-[33%] tablet:my-0 my-4">
          <p className=" desktop:text-[84px] desktop:leading-[84px] laptop:text-[76px] laptop:leading-[76px] tablet:text-[70px] tablet:leading-[70px] text-[66px] leading-[66px] my-2 font-medium">
            100
          </p>
          <Caption color="text-gray3" weight="font-medium">
            {t('why.domain_serviced', {
              appName: APP_NAME,
            })}
          </Caption>
        </div>

        <div className="small:w-[33%] tablet:my-0 my-4">
          <p className=" desktop:text-[84px] desktop:leading-[84px] laptop:text-[76px] laptop:leading-[76px] tablet:text-[70px] tablet:leading-[70px] text-[66px] leading-[66px] my-2 font-medium">
            24/7
          </p>
          <Caption color="text-gray3" weight="font-medium">
            {t('why.our_experts')}
          </Caption>
        </div>

        <div className="small:w-[33%] tablet:my-0 my-4">
          <p className=" desktop:text-[84px] desktop:leading-[84px] laptop:text-[76px] laptop:leading-[76px] tablet:text-[70px] tablet:leading-[70px] text-[66px] leading-[66px] my-2 font-medium">
            10 <span className="text-2xl font-bold">{t('why.year')}</span>
          </p>
          <Caption weight="font-medium" color="text-gray3">
            {t('why.making_domain')}
          </Caption>
        </div>
      </div>
    </div>
  )
}

export default WhyUztelecom
